import { useEffect, useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import SingleChapter from "./SingleChapter"
import { documentationApi } from "../../../services/api"

const SingleChapterPage = () => {
  const { docId, chapterId } = useParams()
  const navigate = useNavigate()
  const [doc, setDoc] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    if (!docId) return
    let mounted = true
    setLoading(true)
    setError("")
    documentationApi.get(docId)
      .then((res) => {
        if (!mounted) return
        setDoc(res?.data?.data || null)
      })
      .catch((e) => {
        if (!mounted) return
        setError(e?.response?.data?.message || e.message || "Failed to load chapter")
      })
      .finally(() => {
        if (!mounted) return
        setLoading(false)
      })
    return () => { mounted = false }
  }, [docId])

  const chapter = useMemo(() => {
    const list = Array.isArray(doc?.chapters) ? doc.chapters : []
    return list.find((ch) => String(ch._id) === String(chapterId)) || null
  }, [doc?.chapters, chapterId])

  if (loading) return <div className="p-4 text-slate-600 animate-soft-pulse">Loading chapter...</div>

  if (!doc || !chapter) {
    return (
      <div className="p-4">
        <p className="text-error text-sm">{error || "Chapter not found."}</p>
      </div>
    )
  }

  return (
    <SingleChapter
      setPage={(page) => {
        if (page === "Project") navigate("/dashboard/project")
        if (page === "FullDoc") navigate(`/dashboard/project/full/${doc._id}`)
      }}
      doc={doc}
      chapter={chapter}
      onDocUpdate={setDoc}
    />
  )
}

export default SingleChapterPage
